import { AceEditor } from 'modules/aceEditor/AceEditorWrapper';
import type { AceEditorProps } from 'modules/aceEditor/types';
import { useController } from 'react-hook-form';
import { FieldProps } from './types';

type AceEditorFieldProps = FieldProps &
  Omit<AceEditorProps, 'onChange' | 'onBlur' | 'value'> & {
    onBlurField?: () => void;
  };

export const AceEditorField = ({
  name,
  defaultValue,
  control,
  onBlurField,
  ...rest
}: AceEditorFieldProps) => {
  const {
    field: { onChange, onBlur, value },
  } = useController({
    control,
    name,
    defaultValue,
  });

  const handleBlur = () => {
    if (onBlurField) onBlurField();
    if (onBlur) onBlur();
  };

  return (
    <AceEditor {...rest} name={name} value={value || ''} onBlur={handleBlur} onChange={onChange} />
  );
};
